(function () {
  'use strict';

  var BOUND = 'pureaBound';
  function once(el) {
    if (el.dataset[BOUND] === '1') return false;
    el.dataset[BOUND] = '1';
    return true;
  }

  /* ---------------- purchase mode (subscribe / one-time) ---------------- */
  var SUB_KEY = 'purea:submode';

  function subGroups() {
    return document.querySelectorAll('[data-purea-sub]');
  }

  /* options can be hidden while the plan is still applied to every add */
  function subForced() {
    return !!document.querySelector('[data-purea-sub-force]');
  }

  function subMode() {
    var group = subGroups()[0];
    if (!group) return 'onetime';
    var on = group.querySelector('[data-purea-sub-mode][aria-checked="true"]');
    return on ? on.getAttribute('data-purea-sub-mode') : 'onetime';
  }

  function applyMode(mode) {
    Array.prototype.forEach.call(subGroups(), function (group) {
      Array.prototype.forEach.call(group.querySelectorAll('[data-purea-sub-mode]'), function (btn) {
        btn.setAttribute('aria-checked', btn.getAttribute('data-purea-sub-mode') === mode ? 'true' : 'false');
      });
    });
    try { window.sessionStorage.setItem(SUB_KEY, mode); } catch (e) {}
    var chosen = document.querySelector('[data-purea-tier][aria-checked="true"]');
    if (chosen) syncPlan(chosen);
    refreshTierPrices();
  }

  /* ---------------- tier rows follow the purchase mode ---------------- */
  /* a tier row rendered without selling-plan data (the closing block) borrows
     it from the row with the same key that has it */
  function subPriceFor(key) {
    var all = document.querySelectorAll('[data-purea-tier="' + key + '"]');
    for (var i = 0; i < all.length; i++) {
      var v = all[i].getAttribute('data-sub-price');
      if (v) return v;
    }
    return '';
  }

  function refreshTierPrices() {
    var tiers = document.querySelectorAll('[data-purea-tier]');
    if (!tiers.length) return;
    var useSub = subForced() || subMode() === 'subscribe';

    Array.prototype.forEach.call(tiers, function (tier) {
      var sub = tier.getAttribute('data-sub-price') || subPriceFor(tier.getAttribute('data-purea-tier') || '');
      var one = tier.getAttribute('data-price') || '';
      var showSub = useSub && sub;

      var nowEl = tier.querySelector('[data-purea-tier-now]');
      if (nowEl) nowEl.textContent = showSub ? sub : one;

      var saveEl = tier.querySelector('[data-purea-tier-save]');
      if (!saveEl) return;
      var base = tier.getAttribute('data-save') || '';
      if (showSub) {
        var was = parseAmount(tier.getAttribute('data-compare'));
        var now = parseAmount(sub);
        if (!isNaN(was) && !isNaN(now) && was > 0 && now < was) {
          saveEl.textContent = 'You save ' + Math.round((1 - now / was) * 100) + '%';
          return;
        }
      }
      saveEl.textContent = base ? 'You save ' + base : '';
    });
  }

  /* writes the selling_plan input + button price for the active tier and mode */
  function syncPlan(tier) {
    var plan = tier.getAttribute('data-selling-plan') || '';
    var subPrice = tier.getAttribute('data-sub-price') || '';
    var price = tier.getAttribute('data-price') || '';
    var mode = subMode();
    var useSub = (subForced() || mode === 'subscribe') && plan;

    Array.prototype.forEach.call(document.querySelectorAll('[data-purea-selling-plan]'), function (el) {
      el.value = useSub ? plan : '';
      el.disabled = !useSub;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-purea-sub-price]'), function (el) {
      el.textContent = subPrice || price;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-purea-onetime-price]'), function (el) {
      el.textContent = price;
    });
    var shown = useSub && subPrice ? subPrice : price;
    Array.prototype.forEach.call(document.querySelectorAll('[data-purea-cta-price]'), function (el) {
      el.textContent = shown;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-purea-sticky-price]'), function (el) {
      el.textContent = shown;
    });
    updateSavings(tier, shown);
  }

  /* ---------------- total savings row ---------------- */
  /* reads the money strings already on the tier, so it follows whatever
     currency the theme prints and needs no extra config */
  function parseAmount(str) {
    var cleaned = String(str || '').replace(/[^0-9.,]/g, '');
    if (!cleaned) return NaN;
    var m = cleaned.match(/[.,](\d{2})$/);
    var whole, frac;
    if (m) {
      whole = cleaned.slice(0, cleaned.length - 3).replace(/[.,]/g, '');
      frac = m[1];
    } else {
      whole = cleaned.replace(/[.,]/g, '');
      frac = '00';
    }
    var n = Number(whole || '0') * 100 + Number(frac);
    return isNaN(n) ? NaN : n;
  }

  function formatLike(sample, cents) {
    var str = String(sample || '');
    var pre = (str.match(/^[^0-9]*/) || [''])[0];
    var post = (str.match(/[^0-9]*$/) || [''])[0];
    var parts = (cents / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return pre + parts.join('.') + post;
  }

  function updateSavings(tier, shown) {
    var rows = document.querySelectorAll('[data-purea-savings]');
    if (!rows.length) return;
    var compare = tier.getAttribute('data-compare') || '';
    var was = parseAmount(compare);
    var now = parseAmount(shown);
    var diff = (isNaN(was) || isNaN(now)) ? NaN : was - now;
    Array.prototype.forEach.call(rows, function (row) {
      if (isNaN(diff) || diff <= 0) { row.hidden = true; return; }
      var v = row.querySelector('[data-purea-savings-value]');
      if (v) v.textContent = formatLike(compare, diff);
      row.hidden = false;
    });
  }

  function initSub() {
    var groups = subGroups();
    if (!groups.length) return;
    Array.prototype.forEach.call(groups, function (group) {
      Array.prototype.forEach.call(group.querySelectorAll('[data-purea-sub-mode]'), function (btn) {
        if (!once(btn)) return;
        btn.addEventListener('click', function () {
          applyMode(btn.getAttribute('data-purea-sub-mode'));
        });
        btn.addEventListener('keydown', function (e) {
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            applyMode(btn.getAttribute('data-purea-sub-mode'));
          }
        });
      });
    });

    var initial = '';
    try { initial = window.sessionStorage.getItem(SUB_KEY) || ''; } catch (e) {}
    if (initial !== 'subscribe' && initial !== 'onetime') {
      var def = groups[0].querySelector('[data-purea-sub-mode][data-default="true"]');
      initial = def ? def.getAttribute('data-purea-sub-mode') : 'subscribe';
    }
    applyMode(initial);
  }

  /* ---------------- tier selector ---------------- */
  function apply(key) {
    var all = document.querySelectorAll('[data-purea-tier]');
    if (!all.length) return;
    var chosen = null;
    Array.prototype.forEach.call(all, function (btn) {
      var on = btn.getAttribute('data-purea-tier') === key;
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
      if (on && !chosen) chosen = btn;
    });
    if (!chosen) return;

    var label = chosen.getAttribute('data-label') || '';
    var price = chosen.getAttribute('data-price') || '';
    var was = chosen.getAttribute('data-compare') || '';
    var variant = chosen.getAttribute('data-variant') || '';

    Array.prototype.forEach.call(document.querySelectorAll('[data-purea-cta-price]'), function (el) {
      el.textContent = price;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-purea-variant]'), function (el) {
      el.value = variant;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-purea-sticky-name]'), function (el) {
      var suffix = el.getAttribute('data-suffix') || '';
      el.textContent = suffix ? label + ' — ' + suffix : label;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-purea-sticky-price]'), function (el) {
      el.textContent = price;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-purea-sticky-was]'), function (el) {
      el.textContent = was;
      el.hidden = !was;
    });
    var box = chosen.getAttribute('data-box') || '';
    Array.prototype.forEach.call(document.querySelectorAll('[data-purea-box]'), function (el) {
      var v = el.querySelector('[data-purea-box-value]');
      if (v) v.textContent = box;
      el.hidden = !box;
    });

    syncPlan(chosen);

    try { window.sessionStorage.setItem('purea:tier', key); } catch (e) {}
  }

  function initTiers() {
    var all = document.querySelectorAll('[data-purea-tier]');
    if (!all.length) return;
    Array.prototype.forEach.call(all, function (btn) {
      if (!once(btn)) return;
      btn.addEventListener('click', function () {
        apply(btn.getAttribute('data-purea-tier'));
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          apply(btn.getAttribute('data-purea-tier'));
        }
      });
    });

    var initial = null;
    try { initial = window.sessionStorage.getItem('purea:tier'); } catch (e) {}
    if (!initial || !document.querySelector('[data-purea-tier="' + initial + '"]')) {
      var def = document.querySelector('[data-purea-tier][data-default="true"]') || all[0];
      initial = def.getAttribute('data-purea-tier');
    }
    apply(initial);
  }


  /* ---------------- cart drawer ---------------- */
  var CART_DATA = null;
  function cartData() {
    if (CART_DATA) return CART_DATA;
    var el = document.querySelector('[data-purea-cart-data]');
    try { CART_DATA = JSON.parse(el.textContent); } catch (e) { CART_DATA = { variants: {} }; }
    return CART_DATA;
  }

  /* free-bottle companion variant, configured on the drawer section */
  function freeCfg() {
    var host = document.querySelector('[data-purea-drawer-lines]');
    if (!host) return null;
    var id = host.getAttribute('data-free-variant') || '';
    if (!id) return null;
    var map = {};
    (host.getAttribute('data-free-map') || '').split(',').forEach(function (pair) {
      var bits = pair.split(':');
      if (bits.length === 2) map[bits[0].trim()] = parseInt(bits[1], 10) || 0;
    });
    return { id: id, map: map };
  }

  function freeQtyFor(variantId) {
    var c = freeCfg();
    if (!c) return 0;
    return c.map[String(variantId)] || 0;
  }

  /* free-gift companion variants, configured on the drawer section.
     unlike the free bottle these are per BUNDLE, not per paid bottle. */
  function giftCfgs() {
    var host = document.querySelector('[data-purea-drawer-lines]');
    if (!host) return [];
    var out = [];
    for (var i = 1; i <= 2; i++) {
      var id = host.getAttribute('data-gift' + i + '-variant') || '';
      if (!id) continue;
      var map = {};
      (host.getAttribute('data-gift' + i + '-map') || '').split(',').forEach(function (pair) {
        var bits = pair.split(':');
        if (bits.length === 2) map[bits[0].trim()] = parseInt(bits[1], 10) || 0;
      });
      out.push({ id: String(id).trim(), map: map });
    }
    return out;
  }

  function isGiftVariant(variantId) {
    var g = giftCfgs();
    for (var i = 0; i < g.length; i++) if (g[i].id === String(variantId)) return true;
    return false;
  }

  /* ---------------- shipping protection ---------------- */
  var PROTECT_KEY = 'purea:protect';

  function protectCfg() {
    var host = document.querySelector('[data-purea-drawer-lines]');
    if (!host) return null;
    var id = host.getAttribute('data-protect-variant') || '';
    if (!id) return null;
    return {
      id: String(id).trim(),
      on: host.getAttribute('data-protect-default') !== 'false',
      plan: (host.getAttribute('data-protect-plan') || '').trim()
    };
  }

  function isProtectVariant(variantId) {
    var c = protectCfg();
    return !!c && c.id === String(variantId);
  }

  /* the shopper's choice sticks for the session; otherwise the configured default */
  function protectWanted() {
    var c = protectCfg();
    if (!c) return false;
    var stored = null;
    try { stored = window.sessionStorage.getItem(PROTECT_KEY); } catch (e) {}
    if (stored === 'on') return true;
    if (stored === 'off') return false;
    return c.on;
  }

  function setProtectWanted(on) {
    try { window.sessionStorage.setItem(PROTECT_KEY, on ? 'on' : 'off'); } catch (e) {}
  }

  /* keeps the protection line matched to the switch. it never rides alone:
     an otherwise empty cart drops it. */
  function planOf(item) {
    var a = item && item.selling_plan_allocation;
    return a && a.selling_plan ? String(a.selling_plan.id) : '';
  }

  /* protection rides with the order: if the goods are on a subscription it joins the
     same plan, so it is billed again on every renewal instead of only the first order */
  function syncProtect(cart) {
    var c = protectCfg();
    if (!c) return Promise.resolve(cart);

    var line = null, others = 0, subscribed = false;
    cart.items.forEach(function (it) {
      if (String(it.variant_id) === c.id) { line = it; return; }
      others++;
      if (planOf(it)) subscribed = true;
    });

    var want = protectWanted() && others > 0 ? 1 : 0;
    var have = line ? line.quantity : 0;
    var wantPlan = (want && subscribed && c.plan) ? String(c.plan) : '';
    var havePlan = line ? planOf(line) : '';

    if (want === have && wantPlan === havePlan) return Promise.resolve(cart);

    function addIt() {
      var item = { id: Number(c.id), quantity: 1 };
      if (wantPlan) item.selling_plan = Number(wantPlan);
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: [item] })
      }).then(fetchCart);
    }

    if (!line) return want ? addIt() : Promise.resolve(cart);
    if (!want) return changeLine(line.key, 0);
    /* quantity is right but the plan is not: drop the line and re-add it on the plan */
    return changeLine(line.key, 0).then(addIt);
  }

  function renderProtect(cart) {
    var row = document.querySelector('[data-purea-protect]');
    if (!row) return;
    var c = protectCfg();
    var others = 0, line = null;
    cart.items.forEach(function (it) {
      if (c && String(it.variant_id) === c.id) { line = it; return; }
      others++;
    });
    row.hidden = !c || others === 0;

    var on = protectWanted();
    var btn = row.querySelector('[data-purea-protect-toggle]');
    if (btn) btn.setAttribute('aria-checked', on ? 'true' : 'false');

    var price = row.querySelector('[data-purea-protect-price]');
    if (price) {
      var cents = line ? line.price : (cartData().variants[String(c && c.id)] || {}).price;
      price.textContent = typeof cents === 'number' ? money(cents) : '';
    }
  }

  /* ---------------- countdown bar ---------------- */
  var CD_KEY = 'purea:cd';

  function cdTarget(el) {
    var mode = el.getAttribute('data-mode') || 'deadline';
    if (mode === 'deadline') {
      var raw = (el.getAttribute('data-deadline') || '').trim();
      if (!raw) return 0;
      var t = Date.parse(raw);
      return isNaN(t) ? 0 : t;
    }
    /* per-visitor window: the same shopper keeps one window rather than a
       fresh timer on every page view */
    var hours = parseFloat(el.getAttribute('data-window-hours')) || 6;
    var now = Date.now();
    var saved = null;
    try { saved = window.localStorage.getItem(CD_KEY); } catch (e) {}
    var end = saved ? parseInt(saved, 10) : 0;
    if (!end || isNaN(end) || end <= now) {
      end = now + hours * 3600000;
      try { window.localStorage.setItem(CD_KEY, String(end)); } catch (e) {}
    }
    return end;
  }

  function initCountdown() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-purea-countdown]'), function (el) {
      if (!once(el)) return;
      var end = cdTarget(el);
      if (!end) { el.hidden = true; return; }

      var h = el.querySelector('[data-purea-cd-h]');
      var m = el.querySelector('[data-purea-cd-m]');
      var sec = el.querySelector('[data-purea-cd-s]');
      function pad(n) { return (n < 10 ? '0' : '') + n; }

      function tick() {
        var left = end - Date.now();
        if (left <= 0) { el.hidden = true; return; }   /* expired: the bar goes away */
        el.hidden = false;
        var t = Math.floor(left / 1000);
        if (h) h.textContent = pad(Math.floor(t / 3600));
        if (m) m.textContent = pad(Math.floor((t % 3600) / 60));
        if (sec) sec.textContent = pad(t % 60);
        window.setTimeout(tick, 1000);
      }
      tick();
    });
  }

  function initProtect() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-purea-protect-toggle]'), function (btn) {
      if (!once(btn)) return;
      btn.addEventListener('click', function () {
        var next = btn.getAttribute('aria-checked') !== 'true';
        btn.setAttribute('aria-checked', next ? 'true' : 'false');
        setProtectWanted(next);
        refresh();
      });
    });
  }

  /* how many paid bottles one bundle of this variant represents */
  function bundleStep(title) {
    var sp = bundleSplit(title);
    return sp && sp.paid ? sp.paid : 1;
  }

  /* "Buy 2 Get 2 Free" -> { paid: 2, free: 2 } */
  function bundleSplit(title) {
    var m = /buy\s*(\d+)\s*get\s*(\d+)\s*free/i.exec(String(title || ''));
    if (!m) return null;
    return { paid: parseInt(m[1], 10), free: parseInt(m[2], 10) };
  }

  function money(cents) {
    var n = (cents / 100).toFixed(2);
    return '$' + n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function drawerEl() { return document.querySelector('[data-purea-drawer]'); }

  function openDrawer() {
    var d = drawerEl();
    if (!d) return;
    d.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    window.requestAnimationFrame(function () { d.classList.add('is-open'); });
    var x = d.querySelector('.purea-drawer__x');
    if (x) x.focus();
  }

  function closeDrawer() {
    var d = drawerEl();
    if (!d) return;
    d.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    window.setTimeout(function () { d.hidden = true; }, 260);
  }

  /* bottles represented by one unit of a bundle variant: "Buy 2 Get 2 Free" -> 2 paid + 2 free */
  function bottlesPerUnit(variantId, title) {
    if (freeCfg()) return { paid: 1, free: freeQtyFor(variantId) };  /* one unit = one bottle */
    var split = bundleSplit(title);
    var paid = split ? split.paid : 1;
    var free = split ? split.free : freeQtyFor(variantId);
    return { paid: paid || 1, free: free || 0 };
  }

  function lineMarkup(item, cfg) {
    var v = cfg.data.variants[String(item.variant_id)] || {};
    var compare = v.compare || 0;
    var img = item.image || v.image || cfg.data.fallbackImage || '';
    var off = compare > item.price
      ? Math.round((1 - item.price / compare) * 100)
      : 0;

    var per = bottlesPerUnit(item.variant_id, v.title);
    var paidBottles = per.paid * item.quantity;
    var allBottles = (per.paid + per.free) * item.quantity;
    var unitPrice = allBottles > 0 ? Math.round(item.line_price / allBottles) : item.price;

    var bullets = '';
    for (var i = 0; i < cfg.bullets.length; i++) {
      bullets += '<li><span class="purea-drawer__ok" aria-hidden="true">✓</span><span>' + cfg.bullets[i] + '</span></li>';
    }

    return '' +
      '<div class="purea-drawer__line" data-line-key="' + item.key + '" data-line-qty="' + item.quantity + '" data-bundle-paid="' + bundleStep(v.title) + '">' +
        '<div class="purea-drawer__thumb">' +
          (off ? '<span class="purea-drawer__off">-' + off + '%</span>' : '') +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
        '</div>' +
        '<div class="purea-drawer__info">' +
          '<p class="purea-drawer__name">' + (item.product_title || item.title) + '</p>' +
          (cfg.rating ? '<p class="purea-drawer__rating"><span aria-hidden="true">★★★★★</span>' + cfg.rating + '</p>' : '') +
          (bullets ? '<ul class="purea-drawer__bullets">' + bullets + '</ul>' : '') +
          '<div class="purea-drawer__ctrls">' +
            '<div class="purea-drawer__qty">' +
              '<button type="button" data-purea-qty="-1" aria-label="Decrease quantity">−</button>' +
              '<span>' + paidBottles + '</span>' +
              '<button type="button" data-purea-qty="1" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" class="purea-drawer__remove" data-purea-remove>Remove</button>' +
            '<div class="purea-drawer__prices">' +
              (compare > item.price ? '<s>' + money(compare * item.quantity) + '</s>' : '') +
              '<strong>' + money(item.line_price) + '</strong>' +
              (cfg.suffix ? '<em>' + money(unitPrice) + ' ' + cfg.suffix + '</em>' : '') +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
      freeRowMarkup(item, cfg, img);
  }

  function freeRowMarkup(item, cfg, img) {
    if (!cfg.showFree) return '';
    if (freeCfg()) return '';  /* a real free line exists in the cart instead */
    var v = cfg.data.variants[String(item.variant_id)] || {};
    var split = bundleSplit(v.title);
    if (!split || !split.free) return '';
    var units = split.free * item.quantity;

    return '' +
      '<div class="purea-drawer__line purea-drawer__line--free">' +
        '<div class="purea-drawer__thumb">' +
          '<span class="purea-drawer__off purea-drawer__off--free">' + cfg.freeBadge + '</span>' +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
        '</div>' +
        '<div class="purea-drawer__info">' +
          '<p class="purea-drawer__name">' + (cfg.freeTitle || (item.product_title || item.title)) + '</p>' +
          '<p class="purea-drawer__freenote">' + (note || '') + '</p>' +
          '<div class="purea-drawer__ctrls">' +
            '<span class="purea-drawer__freeqty">\u00d7' + units + '</span>' +
            '<div class="purea-drawer__prices">' +
              '<strong>' + money(0) + '</strong>' +
              '<em>' + cfg.freeBadge + '</em>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function freeLineMarkup(item, cfg, data, title, note) {
    var v = data.variants[String(item.variant_id)] || {};
    var img = item.image || v.image || data.fallbackImage || '';
    var charged = item.final_line_price > 0;
    return '' +
      '<div class="purea-drawer__line purea-drawer__line--free" data-line-key="' + item.key + '">' +
        '<div class="purea-drawer__thumb">' +
          '<span class="purea-drawer__off purea-drawer__off--free">' + cfg.freeBadge + '</span>' +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
        '</div>' +
        '<div class="purea-drawer__info">' +
          '<p class="purea-drawer__name">' + (title || item.title) + '</p>' +
          '<p class="purea-drawer__freenote">' + cfg.freeNote + '</p>' +
          '<div class="purea-drawer__ctrls">' +
            '<span class="purea-drawer__freeqty">\u00d7' + item.quantity + '</span>' +
            '<div class="purea-drawer__prices">' +
              '<s>' + money(item.original_line_price) + '</s>' +
              '<strong>' + money(item.final_line_price) + '</strong>' +
              '<em>' + (charged ? '' : cfg.freeBadge) + '</em>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function realFreeMarkup(item, cfg, data) {
    return freeLineMarkup(item, cfg, data, cfg.freeTitle, cfg.freeNote);
  }

  function giftLineMarkup(item, cfg, data) {
    return freeLineMarkup(item, cfg, data, '', cfg.giftNote);
  }

  function renderCart(cart) {
    var d = drawerEl();
    if (!d) return;
    var host = d.querySelector('[data-purea-drawer-lines]');
    var empty = d.querySelector('[data-purea-drawer-empty]');
    var data = cartData();

    var bullets = [];
    try { bullets = JSON.parse(host.getAttribute('data-bullets') || '[]'); } catch (e) {}
    bullets = bullets.map(function (b) { return String(b).trim(); }).filter(Boolean);

    var cfg = {
      data: data,
      bullets: bullets,
      rating: host.getAttribute('data-rating') || '',
      suffix: host.getAttribute('data-unit-suffix') || '',
      showFree: host.getAttribute('data-show-free') === 'true',
      freeTitle: host.getAttribute('data-free-title') || '',
      freeNote: host.getAttribute('data-free-note') || '',
      freeBadge: host.getAttribute('data-free-badge') || 'FREE',
      giftNote: host.getAttribute('data-gift-note') || 'Free gift with your bundle'
    };

    var fc = freeCfg();
    var html = '';
    var compareTotal = 0;
    var freeShown = false;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var vid = String(it.variant_id);
      if (fc && vid === fc.id) continue;   /* rendered once, after the paid line */
      if (isGiftVariant(vid)) continue;    /* gifts render after, as their own lines */
      if (isProtectVariant(vid)) continue; /* shown as the toggle row in the footer */
      html += lineMarkup(it, cfg);
      var v = data.variants[vid] || {};
      compareTotal += (v.compare && v.compare > it.price ? v.compare : it.price) * it.quantity;
      if (fc && !freeShown) {
        for (var j = 0; j < cart.items.length; j++) {
          if (String(cart.items[j].variant_id) === fc.id) {
            html += realFreeMarkup(cart.items[j], cfg, data);
            freeShown = true;
            break;
          }
        }
      }
    }
    for (var g = 0; g < cart.items.length; g++) {
      if (isGiftVariant(String(cart.items[g].variant_id))) {
        html += giftLineMarkup(cart.items[g], cfg, data);
      }
    }
    host.innerHTML = html;
    if (empty) empty.hidden = cart.items.length > 0;
    renderProtect(cart);

    var fcx = freeCfg();
    if (fcx) {
      cart.items.forEach(function (it) {
        if (String(it.variant_id) === fcx.id) compareTotal += it.original_line_price;
      });
    }
    /* every bottle the cart entitles, free ones included */
    var bottles = 0;
    cart.items.forEach(function (it) {
      var bvid = String(it.variant_id);
      if (isGiftVariant(bvid)) return;                 /* a gift is not a bottle */
      if (isProtectVariant(bvid)) return;              /* nor is shipping protection */
      var vv = data.variants[bvid] || {};
      if (fcx && bvid === fcx.id) { bottles += it.quantity; return; }
      var per = bottlesPerUnit(it.variant_id, vv.title);
      bottles += (fcx ? per.paid : per.paid + per.free) * it.quantity;
    });
    var bottleRow = d.querySelector('[data-purea-drawer-bottlerow]');
    var bottleVal = d.querySelector('[data-purea-drawer-bottles]');
    if (bottleVal) {
      var noun = bottleVal.getAttribute('data-noun') || 'bottles';
      var one = bottleVal.getAttribute('data-noun-one') || 'bottle';
      bottleVal.textContent = bottles + ' ' + (bottles === 1 ? one : noun);
    }
    if (bottleRow) bottleRow.hidden = bottles <= 0;

    var savings = compareTotal - cart.total_price;
    var sub = d.querySelector('[data-purea-drawer-subtotal]');
    var saveRow = d.querySelector('[data-purea-drawer-saverow]');
    var saveVal = d.querySelector('[data-purea-drawer-savings]');
    var total = d.querySelector('[data-purea-drawer-total]');
    var ctaPrice = d.querySelector('[data-purea-drawer-ctaprice]');

    if (sub) sub.textContent = money(compareTotal);
    if (saveRow) saveRow.hidden = savings <= 0;
    if (saveVal) saveVal.textContent = '−' + money(savings);
    if (total) total.textContent = money(cart.total_price);
    if (ctaPrice) ctaPrice.textContent = cart.items.length ? '· ' + money(cart.total_price) : '';

    /* upsell: hide when the target bundle is already the one in the cart */
    Array.prototype.forEach.call(d.querySelectorAll('[data-purea-upsell]'), function (u) {
      var target = u.getAttribute('data-target-variant') || '';
      if (!target || !cart.items.length) { u.hidden = true; return; }
      var has = cart.items.some(function (it) { return String(it.variant_id) === target; });
      u.hidden = has;
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function changeLine(key, qty, sellingPlan) {
    var body = { id: key, quantity: qty };
    if (sellingPlan) body.selling_plan = Number(sellingPlan);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  /* keeps the free line's quantity locked to what the paid lines entitle */
  /* keep each gift line matched to the bundles actually in the cart */
  function syncGifts(cart) {
    var cfgs = giftCfgs();
    if (!cfgs.length) return Promise.resolve(cart);
    var data = cartData();
    var fc = freeCfg();

    function bundlesOf(it) {
      var v = data.variants[String(it.variant_id)] || {};
      var step = bundleStep(v.title) || 1;
      return Math.max(1, Math.round(it.quantity / step));
    }

    var chain = Promise.resolve(cart);
    cfgs.forEach(function (g) {
      chain = chain.then(function (c) {
        var want = 0, line = null;
        c.items.forEach(function (it) {
          var vid = String(it.variant_id);
          if (vid === g.id) { line = it; return; }
          if (isGiftVariant(vid)) return;
          if (isProtectVariant(vid)) return;         /* protection is not a bundle */
          if (fc && vid === fc.id) return;           /* free bottles don't earn gifts */
          var per = g.map[vid] || 0;
          if (per > 0) want += per * bundlesOf(it);
        });
        var have = line ? line.quantity : 0;
        if (want === have) return c;
        if (line) return changeLine(line.key, want);
        if (want <= 0) return c;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({ items: [{ id: Number(g.id), quantity: want }] })
        }).then(fetchCart);
      });
    });
    return chain;
  }

  function syncFree(cart) {
    var c = freeCfg();
    if (!c) return Promise.resolve(cart);

    var want = 0, freeLine = null, wantPlan = '';
    cart.items.forEach(function (it) {
      if (String(it.variant_id) === c.id) { freeLine = it; return; }
      if (isProtectVariant(it.variant_id)) return;
      var q = freeQtyFor(it.variant_id) * it.quantity;
      if (q > 0) {
        want += q;
        /* inherit whatever plan the paid bottle is on, so both sit in one contract */
        if (!wantPlan) wantPlan = planOf(it);
      }
    });
    var have = freeLine ? freeLine.quantity : 0;
    var havePlan = freeLine ? planOf(freeLine) : '';
    if (want === have && wantPlan === havePlan) return Promise.resolve(cart);

    function addFree() {
      var item = { id: Number(c.id), quantity: want };
      if (wantPlan) item.selling_plan = Number(wantPlan);
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: [item] })
      }).then(fetchCart);
    }

    if (!freeLine) return want > 0 ? addFree() : Promise.resolve(cart);
    if (want <= 0) return changeLine(freeLine.key, 0);
    /* quantity may be right but the plan wrong: drop it and re-add on the plan */
    if (wantPlan !== havePlan) return changeLine(freeLine.key, 0).then(addFree);
    return changeLine(freeLine.key, want);
  }

  function refresh() {
    return fetchCart().then(syncFree).then(syncGifts).then(syncProtect).then(function (cart) {
      return cart && cart.items ? cart : fetchCart();
    }).then(renderCart);
  }

  function initDrawer() {
    var d = drawerEl();
    if (!d || !once(d)) return;

    Array.prototype.forEach.call(d.querySelectorAll('[data-purea-drawer-close]'), function (b) {
      b.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !d.hidden) closeDrawer();
    });

    d.addEventListener('click', function (e) {
      var line = e.target.closest ? e.target.closest('[data-line-key]') : null;

      var qtyBtn = e.target.closest ? e.target.closest('[data-purea-qty]') : null;
      if (qtyBtn && line) {
        var step = parseInt(qtyBtn.getAttribute('data-purea-qty'), 10);
        var bundleSize = parseInt(line.getAttribute('data-bundle-paid'), 10) || 1;
        step = step * bundleSize;   /* half a "Buy 2 Get 2" is not purchasable */
        /* the row shows bottles; the cart counts bundles, so step the stored quantity */
        var cur = parseInt(line.getAttribute('data-line-qty'), 10);
        if (isNaN(cur)) cur = parseInt(line.querySelector('.purea-drawer__qty span').textContent, 10) || 1;
        d.classList.add('is-busy');
        changeLine(line.getAttribute('data-line-key'), Math.max(0, cur + step))
          .then(refresh)
          .then(function () { d.classList.remove('is-busy'); });
        return;
      }

      if (e.target.closest && e.target.closest('[data-purea-remove]') && line) {
        d.classList.add('is-busy');
        changeLine(line.getAttribute('data-line-key'), 0)
          .then(refresh)
          .then(function () { d.classList.remove('is-busy'); });
        return;
      }

      var up = e.target.closest ? e.target.closest('[data-purea-upsell-btn]') : null;
      if (up) {
        var box = up.closest('[data-purea-upsell]');
        var target = box && box.getAttribute('data-target-variant');
        if (!target) return;
        d.classList.add('is-busy');
        var planEl = document.querySelector('[data-purea-selling-plan]');
        var plan = planEl && !planEl.disabled ? planEl.value : '';
        fetchCart()
          .then(function (cart) {
            var ops = {};
            cart.items.forEach(function (it) { ops[it.key] = 0; });
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
              body: JSON.stringify({ updates: ops })
            });
          })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
              body: JSON.stringify({ items: addItems(target, plan, 1) })
            });
          })
          .then(refresh)
          .then(function () { d.classList.remove('is-busy'); });
      }
    });
  }

  /* line-item property announcing the free units (shows at checkout + on the order) */
  function freeProperty(variantId, bundles) {
    var host = document.querySelector('[data-purea-drawer-lines]');
    if (!host) return null;
    var name = host.getAttribute('data-free-prop-name') || '';
    var tmpl = host.getAttribute('data-free-prop-value') || '';
    if (!name || !tmpl) return null;

    var v = cartData().variants[String(variantId)] || {};
    var split = bundleSplit(v.title);
    var p = (split && split.paid ? split.paid : 1) * bundles;   /* paid bottles, as addItems counts them */

    /* the free bottles this page actually grants. the drawer's free map wins
       over whatever the variant title says, so a tier can be sold as a single
       without the order picking up a "get one free" tag. */
    var n;
    if (freeCfg()) n = freeQtyFor(variantId) * p;
    else n = split ? split.free * bundles : 0;
    if (!n) return null;               /* nothing free -> no tag at all */

    var t = n + p;                     /* what the customer actually receives */
    var out = {};
    out[name] = tmpl
      .replace(/\{n\}/g, String(n))
      .replace(/\{p\}/g, String(p))
      .replace(/\{t\}/g, String(t))
      .replace(/\{s\}/g, n === 1 ? '' : 's');
    return out;
  }

  /* builds the paid line plus its free companion line */
  function addItems(id, sellingPlan, bundles) {
    var items = [];
    /* variants are priced per bottle, so the paid line carries the bundle's
       paid bottle count -- that is what makes the order read 2 / 4 / 6 */
    var pv = cartData().variants[String(id)] || {};
    var psplit = bundleSplit(pv.title);
    var paidQty = (psplit && psplit.paid ? psplit.paid : 1) * bundles;
    var paid = { id: Number(id), quantity: paidQty };
    if (sellingPlan) paid.selling_plan = sellingPlan;
    var props = freeProperty(id, bundles);
    if (props) paid.properties = props;
    items.push(paid);

    var c = freeCfg();
    var n = freeQtyFor(id) * paidQty;   /* free map is per paid bottle */
    if (c && n > 0) {
      /* the free bottle shares a selling plan group with the paid bottle, so it
         carries the same plan and is included in every renewal rather than only
         the first order */
      var freeItem = { id: Number(c.id), quantity: n };
      if (sellingPlan) freeItem.selling_plan = Number(sellingPlan);
      items.push(freeItem);
    }

    /* gifts are per bundle, and like the free bottle carry no selling plan */
    giftCfgs().forEach(function (g) {
      var per = g.map[String(id)] || 0;
      if (per > 0) items.push({ id: Number(g.id), quantity: per * bundles });
    });
    return items;
  }

  /* ---------------- add to cart -> open drawer ---------------- */
  function addToCart(form, id, sellingPlan) {
    var btn = form.querySelector('button[type="submit"]');
    function busy(on) {
      if (!btn) return;
      btn.disabled = on;
      if (on) btn.setAttribute('aria-busy', 'true');
      else btn.removeAttribute('aria-busy');
    }
    busy(true);

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: addItems(id, sellingPlan, 1) })
    })
      .then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, data: d }; });
      })
      .then(function (res) {
        if (!res.ok) throw new Error((res.data && (res.data.description || res.data.message)) || 'add failed');
        if (drawerEl()) {
          return refresh().then(function () {
            openDrawer();
            busy(false);
          });
        }
        window.location.href = '/checkout';
      })
      .catch(function () {
        busy(false);
        window.location.href = form.getAttribute('data-fallback') || '/cart';
      });
  }

  function initCarts() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-purea-form]'), function (form) {
      if (!once(form)) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('[data-purea-variant]');
        var id = input && input.value;
        if (!id) {
          var fb = form.getAttribute('data-fallback') || '';
          if (fb) window.location.href = fb;
          return;
        }
        var planInput = form.querySelector('[data-purea-selling-plan]');
        var plan = planInput && !planInput.disabled ? planInput.value : '';
        addToCart(form, id, plan);
      });
    });
  }

  /* ---------------- faq ---------------- */
  function initFaq() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-purea-faq]'), function (list) {
      var qs = list.querySelectorAll('[data-purea-faq-q]');
      Array.prototype.forEach.call(qs, function (q) {
        if (!once(q)) return;
        q.addEventListener('click', function () {
          var panel = document.getElementById(q.getAttribute('aria-controls'));
          var open = q.getAttribute('aria-expanded') === 'true';
          if (list.getAttribute('data-single') === 'true' && !open) {
            Array.prototype.forEach.call(qs, function (other) {
              if (other === q) return;
              other.setAttribute('aria-expanded', 'false');
              var op = document.getElementById(other.getAttribute('aria-controls'));
              if (op) op.hidden = true;
              var os = other.querySelector('[data-purea-faq-sign]');
              if (os) os.textContent = '+';
            });
          }
          q.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (panel) panel.hidden = open;
          var sign = q.querySelector('[data-purea-faq-sign]');
          if (sign) sign.textContent = open ? '+' : '−';
        });
      });
    });
  }

  /* ---------------- sticky bar ---------------- */
  function initSticky() {
    var bar = document.querySelector('[data-purea-sticky]');
    if (!bar) return;
    var anchor = document.querySelector('[data-purea-sticky-after]');
    if (!anchor) { bar.hidden = false; return; }

    function update() {
      var r = anchor.getBoundingClientRect();
      bar.hidden = r.bottom > 0;
    }

    if (once(bar)) {
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { ticking = false; update(); });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      window.addEventListener('load', update);
    }
    update();
  }

  /* ---------------- header cart icon -> our drawer ---------------- */
  /* the theme ships its own <cart-drawer>; on pages that carry ours, take the
     click first so both cart buttons open the same thing */
  var headerCartWired = false;

  function isCartTrigger(el) {
    if (el.id === 'cart-icon-bubble') return true;
    if (el.getAttribute('data-purea-cart-open') !== null) return true;
    var href = el.getAttribute('href') || '';
    href = href.split('?')[0].split('#')[0].replace(/\/$/, '');
    return href === '/cart' || /\.myshopify\.com\/cart$/.test(href);
  }

  function triggerFor(node) {
    while (node && node !== document) {
      if (node.nodeType === 1) {
        if (node.hasAttribute('data-purea-drawer')) return null;  /* our own drawer's links */
        var tag = node.tagName;
        if ((tag === 'A' || tag === 'BUTTON') && isCartTrigger(node)) return node;
      }
      node = node.parentNode;
    }
    return null;
  }

  function initHeaderCart() {
    if (headerCartWired) return;
    headerCartWired = true;
    document.addEventListener('click', function (e) {
      if (!drawerEl()) return;            /* no purea drawer here: leave the theme alone */
      if (e.defaultPrevented) return;
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (!triggerFor(e.target)) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      refresh().then(openDrawer, openDrawer);
    }, true);
  }

  /* ---------------- product gallery ---------------- */
  function initGallery() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-purea-gallery]'), function (gal) {
      var wrap = gal.querySelector('[data-purea-gal-main]');
      var main = wrap && wrap.querySelector('img');
      var thumbs = gal.querySelectorAll('[data-purea-thumb]');
      if (!main || thumbs.length < 2) return;   /* nothing to switch between */

      function select(btn) {
        var full = btn.getAttribute('data-full');
        if (!full) return;
        main.setAttribute('srcset', btn.getAttribute('data-srcset') || '');
        main.setAttribute('sizes', '(min-width: 750px) 46vw, 100vw');
        main.setAttribute('src', full);
        main.setAttribute('alt', btn.getAttribute('data-alt') || '');
        Array.prototype.forEach.call(thumbs, function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
      }

      Array.prototype.forEach.call(thumbs, function (btn, i) {
        if (!once(btn)) return;
        btn.addEventListener('click', function () { select(btn); });
        btn.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = thumbs[i + 1] || thumbs[0];
          if (e.key === 'ArrowLeft') next = thumbs[i - 1] || thumbs[thumbs.length - 1];
          if (!next) return;
          e.preventDefault();
          next.focus();
          select(next);
        });
      });
    });
  }

  function boot() {
    initGallery();
    initDrawer();
    initHeaderCart();
    initSub();
    initTiers();
    /* forced-subscribe pages have no widget, so nothing else triggers this
       and the tier rows would keep showing the one-time price */
    refreshTierPrices();
    initCarts();
    initProtect();
    initCountdown();
    initFaq();
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (!window.__pureaLandingWired) {
    window.__pureaLandingWired = true;
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:section:unload', boot);
  }
})();
